import { useTranslation } from "react-i18next";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import ManagedTextField from "utils/edit/ManagedTextField";
import { ChangeEvent } from "utils/history/Event";
import { asTitle } from "utils/Utils";

import { TextField } from "core/field/FieldService";
import { FormFieldExpansionProps } from "core/field/form/FormFieldRow";

export type TextFormFieldExpansionProps = FormFieldExpansionProps & {
	field: TextField;
};

const TextFormFieldExpansion: React.FC<TextFormFieldExpansionProps> = (
	props: TextFormFieldExpansionProps
) => {
	const { t } = useTranslation();

	function handleValueChange(value: string) {
		const event = new ChangeEvent("/value", props.field.value, value);
		props.onChange(event);
	}

	return (
		<Grid container direction={"column"} alignItems="flex-start">
			<Grid item container alignItems="center">
				<Grid item xs={6} sm={4} md={3} lg={2}>
					<Typography variant="subtitle2">
						{asTitle(t("default"))}
					</Typography>
				</Grid>
				<Grid item xs={6} sm={4} md={3} lg={2}>
					<ManagedTextField
						id={props.field.name}
						fullWidth
						disabled={!props.editable}
						value={props.field.value ?? ""}
						onUpdate={handleValueChange}
						variant="standard"
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default TextFormFieldExpansion;
